export default __webpack_public_path__ + "static/media/icon-apps.9f433d7f.svg";